import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import AsyncStorage from '@react-native-async-storage/async-storage'

interface BasicInformationStore {
  firstName: string
  lastName: string
}
interface IUseBasicInformationStore {
  basicInformation: BasicInformationStore | undefined
  setBasicInformation: (basicInformation: BasicInformationStore | undefined) => void
}

export const useBasicInfoCardApplicationStore = create(
  persist<IUseBasicInformationStore>(
    (set) => ({
      basicInformation: undefined,
      setBasicInformation: (basicInformation: BasicInformationStore | undefined) =>
        set({ basicInformation }),
    }),
    {
      name: 'basic-information-storage',
      storage: createJSONStorage(() => AsyncStorage),
    },
  ),
)

export default useBasicInfoCardApplicationStore
